export type AchievementEventRequest = {
	readonly eventType: EventType
	readonly origin?: Origin | null
	readonly achievementId?: string
};

export enum EventType {
	TUTORIAL_COMPLETED = 'TUTORIAL_COMPLETED',
	LOGIN_WITH_ORIGIN = 'LOGIN_WITH_ORIGIN',
	FEEDBACK_SENT = 'FEEDBACK_SENT'
}

export enum Origin {
	WEB = 'WEB',
	APP = 'APP'
}
